export const isFirefox = (): boolean =>
  typeof navigator !== 'undefined' && /Firefox\/\d/i.test(navigator.userAgent);
